export function toggleCollapse(evt, target) {
    if (!target) {
        console.log('toggleCollapse called without target');
        if (!(evt.target instanceof Element))
            return;
        const t = evt.target.closest('.collapsible');
        if (!t || !(t instanceof HTMLElement))
            return;
        target = t;
    }
    else if (typeof target === 'string') {
        const t = document.getElementById(target);
        if (!t)
            return;
        target = t;
    }
    if (!(evt.target instanceof Element))
        return;
    const btn = evt.target.closest('.btn-collapse');
    if (target.classList.contains('expanded')) {
        target.classList.remove('expanded');
        if (btn && (btn instanceof HTMLElement)) {
            btn.classList.remove('expanded');
        }
    }
    else {
        target.classList.add('expanded');
        if (btn && (btn instanceof HTMLElement)) {
            btn.classList.add('expanded');
        }
    }
    // Keep collapsed content out of the tab order / accessibility tree, and reflect
    // the open state on any triggers that point at this collapsible via aria-controls.
    const expanded = target.classList.contains('expanded');
    target.toggleAttribute('inert', !expanded);
    if (target.id) {
        document.querySelectorAll(`[aria-controls="${target.id}"]`).forEach((trigger) => {
            trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    }
    return;
}
